<template>
  <div class="reference-labels-container">
    <CitationInfoLabel :label="source?.type" :source="source" />
    <div v-if="source?.name">·</div>
    <div v-if="source?.name" class="reference-doc-wrapper">
      <img v-if="source?.logo" :src="source.logo" :alt="source.name || 'logo'" class="logo" />
      <TextBody :text="source.name" weight="medium" tag="span" className="reference-doc" />
    </div>

    <div v-if="docType">·</div>
    <TextBody v-if="docType" :text="docType" weight="medium" tag="span" className="reference-doc" />
  </div>
</template>

<script>
import CitationInfoLabel from '~/components/conversation/chatMessage/CitationInfoLabel.vue';
import TextBody from '~/components/common/TextBody';

export default {
  name: 'ReferenceDetailsLabels',
  components: { CitationInfoLabel, TextBody },
  props: {
    source: {
      type: Object,
      default: () => ({}),
    },
    docType: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.reference-labels-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: $bb-spacing-2;
}

.reference-doc-wrapper {
  display: flex;
  align-items: center;
  gap: $bb-spacing-1;
  white-space: nowrap;
}

:deep(.body-1.reference-doc) {
  color: $bb-neutral-2 !important;
  font-size: 12px;
  text-transform: capitalize !important;
  white-space: nowrap;
}
</style>
